document.addEventListener('DOMContentLoaded', function () {
  const form = document.querySelector('form[name="candidate_search"]');

  if (form) {
    const inputField = document.querySelector('#candidate_search_name');
    const error = document.querySelector('.candidate-error-message');

    form.addEventListener('submit', (event) => {
      if (inputField.value.length < 3) {
        event.preventDefault();
        error.style.display = 'block';
      } else {
        error.style.display = 'none';
      }
    });
  }
});
